import parsePhoneNumber from 'libphonenumber-js';
import { isUndefined } from 'lodash';

import { isValidCountryCode } from './countryCode';

export const isPhoneNumber = (value: unknown, { validateOnlyCountry = false } = {}): boolean => {
  if (typeof value !== 'string') {
    return false;
  }

  const parsed = parsePhoneNumber(value);

  if (isUndefined(parsed)) {
    return false;
  }

  const countryCode = parsed.country?.toString();

  return !!countryCode && isValidCountryCode(countryCode) && (validateOnlyCountry || parsed.isValid());
};
